<template>
  <div class="password-validation uk-child-width-1-2@s uk-grid-small p-4" uk-grid>
    <!-- İlk Şifre Alanı -->
    <div>
      <h5 class="uk-text-bold mb-2">{{ $t('profile.login_password') }}</h5>
      <div class="uk-position-relative">
        <input
            ref="passwordInput"
            v-model="localPassword"
            :name="`new_pass_${localPassword}`"
            :type="showPassword ? 'text' : 'password'"
            autocomplete="new-password"
            class="uk-input mb-1"
            inputmode="text"
            @focus="disableAutofill"
            @mouseup="copyPassword"
        >
        <button
            class="uk-position-center-right uk-position-small"
            style="background: none; border: none; cursor: pointer;"
            type="button"
            @click="togglePasswordVisibility"
        >
          <i :class="showPassword ? 'fa-eye-slash' : 'fa-eye'" class="fa"></i>
        </button>
      </div>

      <!-- Şifre kuralları -->
      <ol class="bg-white W-100 pt-1 pl-2 mb-1">
        <li v-if="passwordValidation.hasUpperLetter" class="uk-text-small m-0" style="color:grey;">
          <i class="fa fa-check mr-1"></i> {{ $t('errors.password_must_have_upper_latter') }}
        </li>
        <li v-if="passwordValidation.hasLowerLetter" class="uk-text-small m-0" style="color:grey;">
          <i class="fa fa-check mr-1"></i> {{ $t('errors.password_must_have_lower_latter') }}
        </li>
        <li v-if="passwordValidation.hasNumber" class="uk-text-small m-0" style="color:grey;">
          <i class="fa fa-check mr-1"></i> {{ $t('errors.password_must_have_number') }}
        </li>
        <li v-if="passwordValidation.hasAtLeast8Letters" class="uk-text-small m-0" style="color:grey;">
          <i class="fa fa-check mr-1"></i> {{ $t('errors.password_must_more_than_7') }}
        </li>

        <!-- Eksikler -->
        <li v-if="!passwordValidation.hasUpperLetter" class="uk-text-small m-0" style="color:red;">
          <i class="fa fa-dot-circle mr-1" style="font-size:9px"></i>
          {{ $t('errors.password_must_have_upper_latter') }}
        </li>
        <li v-if="!passwordValidation.hasLowerLetter" class="uk-text-small m-0" style="color:red;">
          <i class="fa fa-dot-circle mr-1" style="font-size:9px"></i>
          {{ $t('errors.password_must_have_lower_latter') }}
        </li>
        <li v-if="!passwordValidation.hasNumber" class="uk-text-small m-0" style="color:red;">
          <i class="fa fa-dot-circle mr-1" style="font-size:9px"></i>
          {{ $t('errors.password_must_have_number') }}
        </li>
        <li v-if="!passwordValidation.hasAtLeast8Letters" class="uk-text-small m-0" style="color:red;">
          <i class="fa fa-dot-circle mr-1" style="font-size:9px"></i>
          {{ $t('errors.password_must_more_than_7') }}
        </li>
      </ol>
    </div>

    <!-- Şifre Tekrarı alanı -->
    <div>
      <h5 class="uk-text-bold mb-2">{{ $t('profile.login_password_confirm') }}</h5>
      <div class="uk-position-relative">
        <input
            v-model="localPasswordConfirm"
            :name="`confirm_pass_${localPassword}`"
            :type="showPassword ? 'text' : 'password'"
            autocomplete="new-password"
            class="uk-input"
            inputmode="text"
            @focus="disableAutofill"
        >
        <button
            class="uk-position-center-right uk-position-small"
            style="background: none; border: none; cursor: pointer;"
            type="button"
            @click="togglePasswordVisibility"
        >
          <i :class="showPassword ? 'fa-eye-slash' : 'fa-eye'" class="fa"></i>
        </button>
      </div>

      <li v-if="!isMatched" class="uk-text-small m-0" style="color:red;">
        <i class="fa fa-check mr-1"></i>
        {{ $t('errors.password_not_match') }}
      </li>
    </div>
  </div>
</template>

<script>
export default {
  name: "PasswordFields",
  props: {
    password: {
      type: String,
      default: null
    },
    passwordConfirmation: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      localPassword: this.password,
      localPasswordConfirm: this.passwordConfirmation,
      showPassword: false,
      copied: false
    };
  },
  computed: {
    isMatched() {
      if (!this.localPassword || !this.localPasswordConfirm) {
        this.$emit('update:isMatched', false);
        return false;
      }
      const matched = this.localPasswordConfirm === this.localPassword;
      this.$emit('update:isMatched', matched);
      return matched;
    },
    passwordValidation() {
      const val = this.localPassword || '';
      return {
        hasLowerLetter: /[a-z]/.test(val),
        hasUpperLetter: /[A-Z]/.test(val),
        hasNumber: /[0-9]/.test(val),
        hasAtLeast8Letters: val.length > 7
      };
    }
  },
  watch: {
    localPassword(newVal) {
      this.$emit('update:password', newVal);
    },
    localPasswordConfirm(newVal) {
      this.$emit('update:passwordConfirmation', newVal);
    },
    password(newVal) {
      this.localPassword = newVal;
    },
    passwordConfirmation(newVal) {
      this.localPasswordConfirm = newVal;
    }
  },
  methods: {
    async copyPassword() {
      try {
        if (this.localPassword) {
          await navigator.clipboard.writeText(this.localPassword); // Şifreyi kopyala
          this.copied = true;
          setTimeout(() => (this.copied = false), 2000); // 2 saniye sonra mesaj kaybolur
        }
      } catch (err) {
        console.error("Kopyalama başarısız:", err);
      }
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    disableAutofill(e) {
      // Chrome autofill dropdown'unu bastırmak için hack
      // Mobil cihazlarda bu işlemi atlayoruz çünkü readonly klavyenin açılmasını engelliyor
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      if (isMobile) return;

      e.target.setAttribute('readonly', true);
      this.$nextTick(() => {
        e.target.removeAttribute('readonly');
      });
    }
  }
};
</script>

<style scoped>
.password-validation input {
  height: 44px !important;
  user-select: text !important;
}
</style>
